import { createAsyncThunk } from "@reduxjs/toolkit";

import { type InvoiceKsefMetadata } from "@fitness-app/data-models/entities/Order";
import { getErrorMessage } from "@fitness-app/utils";

import { type AsyncThunkCreator } from "../../../index";
import { PRODUCT_CLIENT_REDUCER } from "../types";

type Payload = {
  orderId: string;
  productId: string;
};

type Result = {
  ksef: InvoiceKsefMetadata | null;
};

export const refreshKsefStatus = createAsyncThunk<Result, Payload, AsyncThunkCreator<string>>(
  `${PRODUCT_CLIENT_REDUCER}/refreshKsefStatus`,
  async (payload, { rejectWithValue, extra: { invoicesApi } }) => {
    try {
      const { data } = await invoicesApi.post<Result>("/refresh-ksef-status", payload);

      return data;
    } catch (e) {
      return rejectWithValue(getErrorMessage(e));
    }
  },
);
